import React, { useState } from 'react'
import { Modal, Header, Button, Form as FormUi } from 'semantic-ui-react'
import Axios from 'axios';
import { connect } from 'react-redux';

const ImportFile = (props) => {
    const [file, setFile] = useState(0);
    const [isloading, setisloading] = useState(false);
    const handleFile = (e) => {
        let file = e.target.files[0];
        setFile(file)
    }
    const templateDownload = () => {
        let fileName = props.templateFileName
        let url = `http://dev-scctgateway.elixia.tech/masters/static/${fileName}.xlsx`
        window.location.href = url
    }
    let handleUpload = (e) => {
        e.preventDefault();
        setisloading(true)
        if (file === '' || file === null || file === undefined) {

            setisloading(false)
        } else if (file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {

            setisloading(false)
        } else {
            let fromData = new FormData();
            let customerNo = props.loginReducer.loginUsers.customerNo
            let userId = props.loginReducer.loginUsers.userId
            fromData.append("order-excel", file)
            fromData.append('customer_no', customerNo)
            fromData.append('user_id', userId)
            let gett = props.loginReducer.loginUsers.token;
            var url = `${process.env.REACT_APP_MAIN_URL}/optimization-engine/client/order/import`
            Axios.post(url, fromData, { headers: { 'content-type': 'multipart/form-data', 'Authorization': `${gett}` } })
                .then(response => {
                    // console.log('...', response)
                    if (response.data.status === 200) {
                        if (response.data.rowErrors.length > 0) {
                            alert(response.data.message)
                            setisloading(false)
                        }
                    } else {
                        window.location.reload()
                        props.updated(true)
                        setisloading(false)
                    }
                })
                .catch(err => {
                    alert(err.response.data.message);
                    setisloading(false)
                    console.log(">> err", err);
                });
        }
    }
    return (
        <div>
            <Modal
                open={props.openBox}
                onClose={props.handleClose}
                size="tiny"
            >
                <Header>Import File</Header>
                <Modal.Content>
                    <Modal.Description>
                        <FormUi.Group inline>
                            <FormUi.Field>
                                <label className="tiny ui form p-bold-600">Import Data Using Excel Sheet(Format- xls,xlsx).</label>
                            </FormUi.Field>
                        </FormUi.Group>
                        <FormUi.Group inline>
                            <FormUi.Field>
                                <label className="tiny ui form p-bold-300 w3-text-grey  pt-3">Upload File &nbsp;</label>
                                <input onChange={handleFile} type="file" className="w3-small" id="validatedCustomFile" />
                            </FormUi.Field>
                            <FormUi.Field>
                                <label className="tiny ui form pt-3">
                                    <span className="p-bold-600 ">Download Excel Template from <span className="w3-text-blue p-bold-300" onClick={templateDownload} style={{ cursor: "pointer" }}>Here</span></span>
                                </label>
                            </FormUi.Field>
                        </FormUi.Group>
                    </Modal.Description>
                </Modal.Content>
                <Modal.Actions>
                    {isloading ? <small>Loading...</small> : ''}
                    <Button onClick={props.handleClose} size="mini">Cancel</Button>
                    <Button onClick={handleUpload} disabled={isloading ? true : false} color='blue' size="mini">Upload</Button>
                </Modal.Actions>
            </Modal>
        </div>
    )
}

const mapStateToProps = ({ loginReducer }) => {
    return {
        loginReducer,
    }
}
export default connect(mapStateToProps, null)(ImportFile)
